import { useState } from "react";

const default_ttms = 7 * 24 * 60 * 60 * 1000;

const key_prefix = "cache__";

const useLocalStorageCache = (key, defaultValue, ttms = default_ttms) => {
  const full_key = key_prefix + key;
  const [localStorageValue, setLocalStorageValue] = useState(() => {
    try {
      if (!full_key) return defaultValue;

      const raw = localStorage.getItem(full_key);
      if (!raw) {
        const initial = {
          value: defaultValue,
          timestamp: Date.now(),
          ttms,
        };
        localStorage.setItem(full_key, JSON.stringify(initial));
        return defaultValue;
      }

      const parsed = JSON.parse(raw);

      return parsed.value;
    } catch {
      localStorage.removeItem(full_key);
      return defaultValue;
    }
  });

  const setLocalStorageStateValue = (valueOrFn) => {
    if (!full_key) return;

    const newValue =
      typeof valueOrFn === "function"
        ? valueOrFn(localStorageValue)
        : valueOrFn;

    const payload = {
      value: newValue,
      timestamp: Date.now(),
      ttms,
    };

    localStorage.setItem(full_key, JSON.stringify(payload));
    setLocalStorageValue(newValue);
  };

  return [localStorageValue, setLocalStorageStateValue];
};

export default useLocalStorageCache;

export const cleanupLocalStorageCache = () => {
  const now = Date.now();
  Object.keys(localStorage).forEach((key) => {
    if (!key.startsWith(key_prefix)) return;

    try {
      const raw = localStorage.getItem(key);
      if (!raw) return;

      const parsed = JSON.parse(raw);
      const ttl = parsed.ttms ?? default_ttms;

      if (!parsed.timestamp || now - parsed.timestamp > ttl) {
        localStorage.removeItem(key);
      }
    } catch {
      localStorage.removeItem(key);
    }
  });
};
